import { t } from "@lingui/macro"

import { StatusChip } from "src/components/StatusChip/index"

import { IAlertStatusChipProps } from "src/views/alerts/components/AlertStatusChip/types"

export const AlertStatusChip = ({ status }: IAlertStatusChipProps) => {
    switch (status) {
        case "published":
            return (
                <StatusChip
                    state="positive"
                    label={t`alerts-view.status-published`}
                />
            )
        case "draft":
            return (
                <StatusChip
                    state="neutral"
                    label={t`alerts-view.status-draft`}
                />
            )
        default:
            return <StatusChip state="other" label="-" />
    }
}
